export interface CatalogSortOption {
  label: string;
  value: string;
}

export const LOADING_PRODUCTS_SKELETONS_COUNT = 15;

export enum SortFieldsE {
  Relevance = 'score',
  Price = 'price',
  Id = 'id'
}

export enum SortDirectionsE {
  Ascending = 'asc',
  Descending = 'desc'
}

export const RELEVANCE_SORT_OPTION = `${SortFieldsE.Relevance} ${SortDirectionsE.Descending}`;

export const sortOptions: CatalogSortOption[] = [ {
  label: 'Relevance',
  value: RELEVANCE_SORT_OPTION
},
{
  label: 'Price: Low to high',
  value: `${SortFieldsE.Price} ${SortDirectionsE.Ascending}`
},
{
  label: 'Price: High to low',
  value: `${SortFieldsE.Price} ${SortDirectionsE.Descending}`
} ];

export const DEFAULT_PRICE_LOWER_BOUND = 0;
export const DEFAULT_PRICE_UPPER_BOUND = 1_000_000;
